<template>
  <div class="reload-container">
    Atualizado {{ dateFormat(updatedAt) }}
    <WTooltip label="Atualizar dados" position="left">
      <WButton
        data-testid="reload-button"
        icon-button
        size="small"
        icon="icUpdate"
        variant="secondary"
        @click="handleClick"
      />
    </WTooltip>
  </div>
</template>
<script>
import { WButton, WTooltip } from '@alice-health/wonderland-vue'

import { formatDateTime } from '@/utils/date'

export default {
  components: { WTooltip, WButton },
  emits: ['click'],
  data() {
    return {
      updatedAt: new Date()
    }
  },
  methods: {
    dateFormat(date) {
      return formatDateTime(date)
    },
    handleClick() {
      this.$emit('click')
      this.updatedAt = new Date()
    }
  }
}
</script>
<style lang="scss" scoped>
.reload-container {
  display: flex;
  align-items: center;
  gap: var(--gl-spacing-04);
  font-weight: var(--gl-font-weight-semibold);
  font-size: var(--gl-font-size-xxxs);
  line-height: var(--gl-line-height-xxxs);
  letter-spacing: var(--gl-letter-spacing-rule-02);
  color: var(--gl-color-shades-gray-60);
}
</style>
